import { CodeBase } from "./_codeBase";

/**   SPIRIT反映区分*/
export class ReflectSpiritDiv extends CodeBase<ReflectSpiritDiv>
{
    /** SPIRIT反映区分: "01", "（空白）"*/
    public static readonly NONE: ReflectSpiritDiv = new ReflectSpiritDiv("01", "　", "");

    /** SPIRIT反映区分: "02", "○"*/
    public static readonly DONE: ReflectSpiritDiv = new ReflectSpiritDiv("02", "○", "");

    /** SPIRIT反映区分: "03", "不要"*/
    public static readonly UNNECESSARY: ReflectSpiritDiv = new ReflectSpiritDiv("03", "不要", "");

    /**
    * 
    * @param value
    * @param text
    */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): ReflectSpiritDiv[] {
        return [
            ReflectSpiritDiv.NONE,
            ReflectSpiritDiv.DONE,
            ReflectSpiritDiv.UNNECESSARY,
        ];
    }
}
